
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';


import Sortable from 'sortablejs';

import 'jquery-sortablejs';

import {v4 as uuidv4} from 'uuid';
let myuuid = uuidv4();
//window.myuuid = myuuid;
console.log('Your UUID is: ' + myuuid + ' ' + window.myuuid);

import Vue from 'vue';

window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('kb-slick-carousel', require('./components/KBSlickCarousel.vue').default);
Vue.component('dates-carousel', require('./components/DatesCarousel.vue').default);
//Vue.component('VueSlickCarousel', require('./components/KBSlickCarousel.vue').default);
Vue.component('questionnaire', require('./components/Questionnaire.vue').default);


import VueSlickCarousel from 'vue-slick-carousel'
Vue.component('vue-slick-carousel', VueSlickCarousel);

import { VueperSlides, VueperSlide } from 'vueperslides';
//import 'vueperslides/dist/vueperslides.css';
//Vue.component('vueper-slides', VueperSlides);
//Vue.component('vueper-slide', VueperSlide);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

const app = new Vue({
    el: '#app',
});


// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/swiper.scss'
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';
